import axios from 'axios'
import type { AxiosRequestConfig } from 'axios'
import md5 from 'blueimp-md5'

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.cmfssolutips.com'
const API_KEY = 'hfu9CkqRMAVdhq2w'

function getDeviceId(): string {
  const cached = localStorage.getItem('cache_device_id')
  if (cached) return cached
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let id = ''
  for (let i = 0; i < 36; i++) {
    if ([8, 13, 18, 23].includes(i)) {
      id += '-'
    } else {
      id += chars[Math.floor(Math.random() * chars.length)]
    }
  }
  localStorage.setItem('cache_device_id', id)
  return id
}

function obtainApp(): string {
  // H5 web 环境，与原项目保持一致
  return 'IOS'
}

function getPublicParams() {
  const token = localStorage.getItem('token') || ''
  const appInfo = JSON.parse(localStorage.getItem('appInfo') || '{}')
  const timestamp = Date.now().toString()
  const platform = obtainApp()
  const version ='1.0.0'
  const appsFlyerId = ''
  const bundleId = 'com.appios.solutionscmf'

  const sign = token 
    ? md5(timestamp + API_KEY + token + appsFlyerId + bundleId + version + platform)
    : md5(timestamp + API_KEY + appsFlyerId + bundleId + version + platform)

  return {
    bd: {
      version,
      platform,
      appsFlyerId,
      bundleId,
      app_id: appInfo?.app_id || '',
      token: token || undefined,
      timestamp,
      sign,
      app_package_name: 'com.appios.solutionscmf',
      h5_version: '',
      device_id: getDeviceId(),
    },
    token,
  }
}

const instance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
})

instance.interceptors.request.use(
  (config) => {
    console.log('[axios] request interceptor called, url:', config.url)
    try {
    const { bd, token } = getPublicParams()
    const method = config.method?.toLowerCase()

    if (config.url && config.url !== '/appinfo') {
      config.url = '/v2' + config.url
    }

    if (method === 'get') {
      config.params = { ...bd, ...config.params, token }
    } else {
      config.params = { timestamp: bd.timestamp }
      config.data = { ...bd, ...config.data, token }
    }

    config.headers = {
      ...config.headers,
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      'country-language': 'th',
    } as never

    console.log('[axios] final request url:', config.baseURL, config.url, 'params:', config.params)
    return config
    } catch(e) { console.error('[axios] interceptor error:', e); throw e }
  },
  (error) => Promise.reject(error)
)

instance.interceptors.response.use(
  (response) => {
    const url = response.config?.url || ''
    const isVerifyTmp = url.includes('verifytmp')
    if (response.data?.code === 403100 && !isVerifyTmp) {
      localStorage.removeItem('token')
      localStorage.removeItem('user_id')
      localStorage.removeItem('user_name')
      localStorage.removeItem('loginSuccessInfo')
    }
    return response.data
  },
  (error) => Promise.reject(error)
)

export interface ApiResult<T = unknown> {
  code: number
  message: string
  data?: T
}

const http = {
  get<T = unknown>(url: string, config?: AxiosRequestConfig): Promise<ApiResult<T>> {
    return instance.get(url, config)
  },
  post<T = unknown>(url: string, data?: object, config?: AxiosRequestConfig): Promise<ApiResult<T>> {
    return instance.post(url, data, config)
  },
}

export default http
